import { render, staticRenderFns } from "./OperationsDashboard.vue?vue&type=template&id=4928d02c&scoped=true"
import script from "./OperationsDashboard.vue?vue&type=script&lang=js"
export * from "./OperationsDashboard.vue?vue&type=script&lang=js"
import style0 from "./OperationsDashboard.vue?vue&type=style&index=0&id=4928d02c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4928d02c",
  null
  
)

export default component.exports